export const SEARCH_BUTTON_TEXT = "Search packages";
export const OUTBOUND = "Outbound";
export const RETURN = "Return";
